module.exports = __webpack_public_path__ + "img/shape_landing_comofunciona_5.ee571e0a.svg";